export default "__VITE_ASSET__DLTy5toJ__"